import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';


import { Observable } from 'rxjs';
import { Events } from '../models/events';
import { ControllerApiPath } from '../services/constant';
import { SharedServiceService } from '../services/shared-service.service';
@Injectable({
  providedIn: 'root'
})
export class EventServiceService {
  private apiBaseUrl:string;
  constructor(private http: HttpClient,private sharedService: SharedServiceService) { 
    this.apiBaseUrl = sharedService.baseUrl();
  }
  
  addEvent(event: Events){
    const headers = this.sharedService.createAuthorizationHeader();
    
    return this.http.post<Events>(this.apiBaseUrl+ControllerApiPath.events, event, { headers }).pipe(
      map((event: Events) => {
      
        return event;
      })
    )
  }
  // 🆕


 getEvents(loggedInUserId: string, filterDate: Date) {
  const headers = this.sharedService.createAuthorizationHeader();
  const url = this.apiBaseUrl + ControllerApiPath.events;

  return this.http.get<any>(url, { 
    headers, 
    params: {
      loggedInUserId: loggedInUserId,
      filterDate: filterDate.toISOString()
    }
  }).pipe(
    map(res => res?.result ?? []) // always return an array
  );
}


// event.service.ts
getEventById(id: any) {
  const headers = this.sharedService.createAuthorizationHeader();
  const url = this.apiBaseUrl + ControllerApiPath.events + '/' + id;

  // tell Angular HTTP client the payload is { result: Events }
  return this.http.get<{ result: Events }>(url, { headers }).pipe(
    map((response) => response.result) // unwrap here
  );
}


updateEvent(eventDetail: Events, id: any) {
  const headers = this.sharedService.createAuthorizationHeader();

  // Log Google Calendar integration details
  console.log('[GoogleCalendar] Integration details:', {
    hasGoogleCalendarId: !!eventDetail?.googleCalendarId,
    hasGoogleEventId: !!eventDetail?.googleEventId,
    eventEmail: eventDetail?.email || 'Not set',
    timeZone: eventDetail?.timeZone || 'Not set',
    eventDate: eventDetail?.eventDate,
    startTime: eventDetail?.eventStartTime,
    endTime: eventDetail?.eventEndTime
  });

  const payload = {
    eventId: id,
    title: eventDetail.eventTitle,
    eventDate: eventDetail.eventDate,
    startTime: eventDetail.eventStartTime,
    endTime: eventDetail.eventEndTime,
    calendarEventId: eventDetail.calendarEventId || null,
    updateInvitees: eventDetail.updateInvitees,
    eventData: eventDetail  // keeping the full data as well for backward compatibility
  };

  console.log("[GoogleCalendar] Request payload:", {
    ...payload,
    calendarDetails: {
      calendarEventId: eventDetail?.calendarEventId || 'Not set',
      googleCalendarId: eventDetail?.googleCalendarId || 'Missing',
      googleEventId: eventDetail?.googleEventId || 'Missing',
      attendees: eventDetail?.email ? [eventDetail.email] : [],
    }
  });

  return this.http.put<any>(
    this.apiBaseUrl + ControllerApiPath.events + '/' + id,
    payload,
    { headers }
  ).pipe(
    map(response => {
      console.log('[GoogleCalendar] Server response:', {
        status: response?.status || 'No status',
        googleCalendarError: response?.googleCalendarError || 'No error',
        googleCalendarId: response?.googleCalendarId || 'Not returned',
        googleEventId: response?.googleEventId || 'Not returned'
      });
      return response;
    })
  );
}

  deleteEvent(id:any){
    const headers = this.sharedService.createAuthorizationHeader();
    return  this.http.delete<Events>(this.apiBaseUrl + ControllerApiPath.events+'/'+id, { headers })
  }
  getLoggedUser(){
    return this.sharedService.getLoggedInUser();
  }
  // Updated: Use /api/members endpoint for member search
  searchMembers(param: string): Observable<any> {
    const headers = this.sharedService.createAuthorizationHeader();
    // Build the URL as required
  const url = `${this.apiBaseUrl}members`;
    const params = {
      pageSize: '10',
      pageNo: '0',
      name: param,
      teamId: '',
      level: '0',
      filterType: 'none'
    };
    return this.http.get(url, { headers, params });
  }
}